export const RECENT_FILES_OFFSET = 6;
